import { useMemo } from "react";
import { useParams } from "react-router-dom";
import {
  getSessionStatus,
  submitAnswer,
  submitSession,
  getResult,
} from "../../services/External/ExternalSessionService";
import ExamSession from "../ExamTaking/ExamSession";

const API_BASE_URL = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

export default function ExternalExamSession() {
  const { sessionUuid } = useParams();

  const adapter = useMemo(
    () => ({
      fetchAttempt: (_uuid, signal) =>
        getSessionStatus({ sessionUuid, signal }),
      submitAnswer: (_uuid, data, signal) =>
        submitAnswer({ sessionUuid, data, signal }),
      submitAttempt: (_uuid, signal, data) =>
        submitSession({ sessionUuid, data, signal }),
      getResult: (signal) => getResult({ sessionUuid, signal }),
      getExitSubmitRequest: ({ completionReason } = {}) => {
        const sessionToken = sessionStorage.getItem("sessionToken");
        if (!API_BASE_URL || !sessionToken) {
          return null;
        }

        return {
          method: "POST",
          url: `${API_BASE_URL}/external/sessions/${sessionUuid}/submit/`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `SessionToken ${sessionToken}`,
          },
          body: JSON.stringify({ completion_reason: completionReason || "disconnected" }),
        };
      },
    }),
    [sessionUuid]
  );

  return (
    <ExamSession
      apiAdapter={adapter}
      resultPath={`/launch/${sessionUuid}/result`}
      exitPath="/login"
    />
  );
}
